export default __webpack_public_path__ + "static/linkBg5_shadow-89ff00afc69edf0e1c4a954ecbe9b4d0.png";